import React, { useEffect, useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { agreeSupplierSecurityAPI } from '../../../../../api/supply/supplierAPI'
import { useDispatch } from 'react-redux'
import { editSupplierDisagreeSecurityText, editSupplierIsAgreeSecurity } from '../../../../../store/supplierSlice'

const AgreeSecurityForm = ({ supplierBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplierBd ? 
            {
                isAgreeSecurity: supplierBd.isAgreeSecurity,
                disagreeSecurityText: supplierBd.disagreeSecurityText,
            } 
        : {}
    ) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeSupplierSecurityAPI({
            id: supplierBd.id,
            isAgreeSecurity: data.isAgreeSecurity,
            disagreeSecurityText: data.disagreeSecurityText,
        }).then(data => {
            if (data) {
                dispatch(editSupplierIsAgreeSecurity(data.isAgreeSecurity))
                dispatch(editSupplierDisagreeSecurityText(data.disagreeSecurityText))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження підрядника службою безпеки. Всі документи перевірено і з цим підрядником можна працювати
            </p>
        </div>
        {
			formDataProductIsField('agree', 'supplierAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'supplierAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeSecurity', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeSecurity', e)}
					forciblyValue={
                        data && data.isAgreeSecurity === true ? true :
                        data && data.isAgreeSecurity === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplierAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeSecurity === false || data.isAgreeSecurity === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplierAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeSecurityText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeSecurityText', e)}
					forciblyValue={data ? data.disagreeSecurityText : ''}
                    className={data && (data.isAgreeSecurity === false || data.isAgreeSecurity === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeSecurityForm